import React, { useRef, useEffect } from "react";
import VanillaTilt from "vanilla-tilt";
import "../styles/tilt.css";
import { AnimatePresence, motion } from "framer-motion";

import { useAudio } from "./AudioContext";

export default function Tilt({
  image,
  height,
  height2,
  alt,
  date,
  link,
  left = "auto",
  top = "auto",
  left2 = "auto",
  top2 = "auto",
}) {
  const tiltRef = useRef(null);

  const { playAudio, playHover, pauseHover, isMobile } = useAudio();

  const handleLink = () => {
    playAudio();
    window.open(link, "_blank");
  };

  const playSound = (sound) => {
    playHover(sound);
  };

  const stopSound = () => {
    pauseHover();
  };

  useEffect(() => {
    if (tiltRef.current) {
      VanillaTilt.init(tiltRef.current, {
        scale: 1.1,
        max: 25,
        speed: 400,
        glare: true,
        "max-glare": 1,
        gyroscope: false,
      });
    }
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ x: -40, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        ref={tiltRef}
        style={{
          height: isMobile ? `${height2}px` : `${height}px`,
          left: isMobile ? left2 : left,
          top: isMobile ? top2 : top,
        }}
        className="tiltbox"
        onClick={handleLink}
        onMouseEnter={() => playSound(1)}
        onMouseLeave={stopSound}
      >
        <div className="tiltbox-inner">
          <h1>{date}</h1>
          <p>{alt}</p>
          <div className="s-line"></div>
          <div className="arrow-icon">
            <i className="fi fi-rr-arrow-small-right"></i>
          </div>
        </div>
        <img
          height={isMobile ? `${height2}px` : `${height}px`}
          src={image}
          alt={alt}
        />
      </motion.div>
    </AnimatePresence>
  );
}
